import { SVGProps, memo } from 'react'

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <mask
      id="mask0_284_10021"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={24}
      height={24}>
      <circle cx={11.5081} cy={11.5081} r={11.5081} fill="#C4C4C4" />
    </mask>
    <g mask="url(#mask0_284_10021)">
      <circle cx={11.5081} cy={11.5081} r={11.5081} fill="#22202B" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1293 11.0731C14.1114 10.693 13.9965 10.3159 13.7837 9.97507L11.9068 6.96828C11.7637 6.73893 11.6649 6.49328 11.6099 6.24127L11.5315 6.36694C11.0669 7.11115 11.0669 8.02803 11.5315 8.77224L13.0329 11.1777C13.4975 11.922 13.4975 12.8389 13.0329 13.5831L12.9545 13.7088C12.8996 13.4568 12.8007 13.2111 12.6576 12.9819L10.4054 9.37365C10.2623 9.14438 10.1634 8.89864 10.1085 8.64671L10.0301 8.77238C9.5671 9.51408 9.56567 10.4273 10.0254 11.1702L10.0254 11.1702L11.5315 13.5831C11.996 14.3273 11.996 15.2443 11.5315 15.9886L11.453 16.1142C11.3982 15.8622 11.2993 15.6166 11.1562 15.3872L9.27933 12.3804C9.02763 11.9772 8.91258 11.5232 8.93364 11.0735C6.92452 11.559 5.53769 12.5899 5.53769 13.7836C5.53769 15.4442 8.22128 16.7903 11.5315 16.7903C14.8417 16.7903 17.5252 15.4442 17.5252 13.7836C17.5252 12.5899 16.1386 11.5587 14.1293 11.0731Z"
        fill="white"
      />
    </g>
  </svg>
)

export const LogoRoundedSantander = memo(SvgComponent)
